"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseInsecureHttpParserMiddleware = void 0;
/**
 * Some third-party APIs (looking at you, Nursys) return non-confirming
 * HTTP headers, such as containing newlines, or a header starting with a space.
 * Only in this context, we need the ability to disable Node's strict HTTP
 * response parsing. Otherwise, Node throws:
 *   Parse Error: Invalid header value char
 * Using this middleware requires node-fetch@3.x
 */
class UseInsecureHttpParserMiddleware {
    async pre(context) {
        const { url, init } = context;
        return {
            init: {
                ...init,
                insecureHTTPParser: true,
            },
            url,
        };
    }
}
exports.UseInsecureHttpParserMiddleware = UseInsecureHttpParserMiddleware;
//# sourceMappingURL=use-insecure-http-parser.js.map